class CaseStudiesLoader extends HTMLElement {
  constructor() {
    super();
    this.visibleCaseStudies = new Set();
    this.selectedOptions = [];
    this.categoryNames = [];
    this.baseUrl = this.getAttribute('base-url') || '';
  }

  connectedCallback() {
    this.initializeComponent();
  }

  initializeComponent() {
    this.setInitiallyVisibleCaseStudies();
    this.setupEventListeners();
  }

  setInitiallyVisibleCaseStudies() {
    const initialIds = this.getAttribute('initial-ids');
    if (initialIds) {
      initialIds.split(',').forEach((id) => this.visibleCaseStudies.add(id.trim()));
    }
  }

  setupEventListeners() {
    this.addEventListener('filter-changed', this.handleFilterChange.bind(this));
    this.addEventListener('filter-initialized', this.handleFilterInitialization.bind(this));
    const loadMoreButton = this.querySelector('[name="load-more"]');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => this.loadMore());
    }
  }

  handleFilterChange(event) {
    const { selectedOptions, categoryNames } = event.detail;
    this.selectedOptions = selectedOptions;
    this.categoryNames = categoryNames;
    this.loadMore(true);
  }

  handleFilterInitialization(event) {
    const { selectedOptions, categoryNames } = event.detail;
    this.selectedOptions = selectedOptions;
    this.categoryNames = categoryNames;
  }

  async loadMore(isReset = false) {
    try {
      const formData = this.prepareFormData();
      const response = await this.fetchCaseStudies(formData);
      this.handleResponse(response, isReset);
    } catch (error) {
      this.handleLoadError(error);
    }
  }

  prepareFormData() {
    const formData = new FormData();
    formData.append('CEUid', this.getAttribute('ceuid'));
    if (this.visibleCaseStudies.size > 0) {
      formData.append('caseStudyIDs', Array.from(this.visibleCaseStudies).join(','));
    }
    this.selectedOptions.forEach((option) => formData.append('selectedoptions[]', option));
    formData.append('categorynames', this.categoryNames.join(','));
    formData.append('languageUid', this.getAttribute('language-uid'));
    return formData;
  }

  async fetchCaseStudies(formData) {
    const url = `${this.baseUrl}/?caseStudiesList=1&filter=1`;
    const response = await fetch(url, { method: 'POST', body: formData });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return response.json();
  }

  handleResponse(result, isReset) {
    const { maxLength, previewContent } = result;

    if (isReset) {
      this.visibleCaseStudies.clear();
      this.dispatchEvent(
        new CustomEvent('reset-case-studies', {
          bubbles: true,
          composed: true,
        }),
      );
    }

    this.dispatchStudies(previewContent);
    this.updateLoadMoreStatus(previewContent.length, maxLength);
  }

  dispatchStudies(caseStudies) {
    caseStudies.forEach((study) => {
      if (!this.visibleCaseStudies.has(study.uid)) {
        this.visibleCaseStudies.add(study.uid);
        this.dispatchEvent(
          new CustomEvent('new-case-study', {
            detail: study,
            bubbles: true,
            composed: true,
          }),
        );
      }
    });
  }

  updateLoadMoreStatus(contentLength, maxLength) {
    const loadMoreButton = this.querySelector('[name="load-more"]');
    if (loadMoreButton) {
      loadMoreButton.style.display = contentLength <= maxLength ? 'block' : 'none';
    }
  }

  handleLoadError(error) {
    console.error('Error:', error);
    this.dispatchEvent(
      new CustomEvent('case-studies-load-error', {
        detail: error,
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('case-studies-loader', CaseStudiesLoader);
